import script from "./legoSegmentWrapperExtend.vue?vue&type=script&lang=js"
export * from "./legoSegmentWrapperExtend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/lego/extend/legoSegmentWrapperExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58a4e55c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58a4e55c', __exports__)) {
    api.reload('58a4e55c', __exports__)
  }
  
}


export default __exports__